import React from "react";

const VerticalDashIcon = ({
  width = 2,
  height = 14,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 2 14"
    fill="none"
    className={className}
  >
    <path
      d="M1 1V13"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);

export default VerticalDashIcon;
